@if (condition) {
  <ng-content></ng-content>
}
<div class="card-body">
  @if (!condition) {
    <p>{{errorText}}</p>
  }
</div>